/*
import {
  darken,
  lighten,
} from './utils';
*/

export const baseColors = {
  white: '#ffffff',
  black0: '#000000',
  black1: '#1F1F1F',
  black2: '#424242',
  black3: '#888888',
  black4: '#CCCCCC',
  black5: '#F2F2F2',
};

/*
function makeScale(c, n) {
  const scale = [];

  const maxDarken = 0.5;
  const maxLighten = 0.7;

  const nDarken = 2;
  const nLighten = n - 1 - nDarken;
  const stepDarken = maxDarken / nDarken;
  const stepLighten = maxLighten / nLighten;

  for (let i = nDarken; i > 0; i--) {
    scale.push(darken(c, stepDarken * i));
  }
  scale.push(c);
  for (let i = 1; i <= nLighten; i++) {
    scale.push(lighten(c, stepLighten * i));
  }

  scale.reverse();

  return scale;
}
*/

const def = {
  // colors that might be needed in components
  white: baseColors.white,
  black0: baseColors.black0,
  black1: baseColors.black1,
  black2: baseColors.black2,
  black3: baseColors.black3,
  black4: baseColors.black4,
  black5: baseColors.black5,

  // new
  background: '#fff',


  highlight: '#FD912D',

  map_positive_min: '#9B99FC',
  map_positive_mid: '#6473FF',
  map_positive_max: '#4F60FF',
  map_negative_min: '#FF9E57',
  map_negative_mid: '#FF6A29',
  map_negative_max: '#FE5925 ',

  fem_min: '#A8FCDD',
  fem_mid: '#5DDEAF',
  fem_max: '#02B58A',
  male_min: '#FFDE88',
  male_mid: '#FFCB44',
  male_max: '#FE8D25',
};

let colors = { ...def };

function makeExtraColors() {
  colors.bg = colors.background;
}


makeExtraColors();


export function getColors() {
  return colors;
}


export function setColors(cs) {
  colors = { ...def };
  Object.keys(cs).forEach((k) => {
    if (cs[k]) colors[k] = cs[k];
  });
  makeExtraColors();
}
